import React from "react"
import { node } from "prop-types"

import Header from "./Header"
import Sidebar from "./Sidebar"
import Footer from "./Footer"

const Base = ({ children }) => (
  <div className="wrapper">
    <Header />
    <Sidebar />
    <section>{children}</section>
    <Footer />
  </div>
)
Base.propTypes = {
  children: node,
}
export default Base



// WEBPACK FOOTER //
// ./src/components/layout/Base.js